<template>
  <div class="pc_scroll-tab">
    <!-- 头部导航 -->
    <PC-scroll ref="scroll" :data="list" :click="true" class="scroll">
      <ul class="activity-rule-nav">
        <template>
          <li
            v-for="(item, index) in list"
            :key="index"
            :class="[
              index == active || (item.brandId && activeId && activeId == item.brandId)
                ? 'active'
                : ''
            ]"
            @click="handleSetActive(item, index, $event)"
          >
            <!-- {{ item.tabName || item.name || item.categoryName || item.brandName }} -->
            <!-- Móviles -->
             {{ $t('product.category.mobiles') }}
          </li>
        </template>
      </ul>
    </PC-scroll>
  </div>
</template>
<script>
import PCScroll from '../PCScroll';
export default {
  components: {
    PCScroll
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    active: {
      type: Number,
      default: 0
    },
    type: {
      type: String,
      default: ''
    },
    // 默认是品牌id
    activeId: {
      type: Number || String,
      default: null
    },
    // 默认选中的id
    id: {
      type: Number || String,
      default: null
    }
  },
  data() {
    return {
      // active: 0,
      // list: [],
      sortList: [],
      tabId: null
    };
  },
  watch: {
    /**
     * 防止进来的URL不携带?brandId，监控brandList获取到数据后，默认获取下标为0的brand产品
     */
    // brandList: {
    //   immediate: true,
    //   handler: function(n, o) {
    //     if (this.is_max_screen) {
    //       if (n && n.length && (!this.$route.query || !this.$route.query.brandId)) {
    //         this.$nextTick(() => {
    //           this.queryProductById(n[0]['brandId'])
    //         })
    //       } else {
    //         this.queryProductById(this.$route.query.brandId)
    //       }
    //     }
    //   }
    // }
  },
  methods: {
    handleSetActive(item, index, event) {
      const data = {
        ...item,
        index
      };
      this.$emit('handleSetActive', data);
      // let className
      // switch (this.type) {
      //   case 'first':
      //     className = 'category1'
      //     this.$emit('hasChildList', item.childList)
      //     // this.$store.dispatch('setSecondCategoryId', item.categoryId)
      //     break
      //   case 'second':
      //     className = 'category2'
      //     break
      //   case 'brand':
      //     className = 'category3'
      //     break
      // }
      // // 当前判断处理分类数据的左右滑动
      // if (this.active !== index) {
      //   if (className !== 'category3') {
      //     // 切换类目获取分类下的品牌列表
      //     let id = item.childList && item.childList.length ? item.childList[0].categoryId : item.categoryId
      //     this.$store.dispatch('setCategoryId', id)
      //     this.$store.dispatch('queryBrandList')
      //   } else {
      //     // 点击品牌获取品牌下面机型
      //     this.queryProductById(item.brandId)
      //   }
      //   // this.active = index
      //   let data = {
      //     type: className,
      //     index: index
      //   }
      //   this.$emit('changeActiveiIndex', data)
      //   let timer = setTimeout(() => {
      //     let li = document.querySelector(`.${className} .scroll ul .active`)
      //     this.$refs.scroll.scrollToElement(li, 50, true, true)
      //     clearTimeout(timer)
      //   }, 100)
      // } else if (index === 0) {
      //   let timer = setTimeout(() => {
      //     let li = document.querySelector(`.${className} .scroll ul .active`)
      //     this.$refs.scroll.scrollToElement(li, 50, true, true)
      //     clearTimeout(timer)
      //   }, 200)
      // }
    },
    handleNoData(data) {
      setTimeout(() => {
        this.$emit('handleNoData', data);
      }, 100);
    },
    initResponse(data) {
      const sortList = [];
      data.forEach((val, index) => {
        if (val.body && val.body.textList) {
          data[index].body.textList = val.body.textList.map((sub, num) => {
            sub.body = sub.body.split('\n');
            return sub;
          });
        }
        // 重排序
        const arr = new Array(3);
        for (const key in val) {
          if (Object.prototype.toString.call(val[key]) === '[object Object]') {
            arr[parseInt(val[key].sort)] = val[key];
          }
        }
        sortList.push(arr);
      });
      // 已按 sort 排序
      this.sortList = sortList;
      this.list = data;
      // this.list = []
    },
    // 点击品牌后，根据品牌id查询获取品牌的产品列表
    queryProductById(id) {
      if (id) {
        id = parseInt(id);
        let num = 0;
        this.list.map(item => {
          if (item.brandId === id) {
            num++;
          }
        });
        if (num === 1) {
          // this.active = id
          this.$store.dispatch('productListScrollToStartPosition', id);
          this.$store.dispatch('queryProductList', { brandId: id });
        } else if (this.list && this.list[0] && this.list[0].brandId) {
          // this.active = this.list[0].brandId
          this.$store.dispatch('productListScrollToStartPosition', this.list[0].brandId);
          this.$store.dispatch('queryProductList', { brandId: this.list[0].brandId });
        }
      }
    }
  }
};
</script>
<style scoped lang="less">
.pc_scroll-tab {
  height: 100%;
  width: 100%;
  overflow-x: hidden;
  .scroll {
    height: 100%;
    overflow: hidden;
    float: left;
    text-align: center;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    width: 100%;
  }
  .activity-rule-nav {
    display: flex;
    align-items: center;
    height: 100%;
    font-size: 16px;
    cursor: pointer;
    .active {
      color: #405FFF;
    }
    li {
      color: #282828;
      margin-right: 60px;
    }
  }
  .activity-rule-nav {
    font-size: 16px;
    // margin: 0px auto;
    text-align: center;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .activity-rule-nav li {
    white-space: nowrap;
    text-align: center;
    display: block;
    box-sizing: border-box;
    cursor: pointer;
    // overflow: hidden;
    position: relative;
    margin-right: 60px !important;
    font-size: 16px;
  }
}
</style>
